import type { SsoConfig } from '@alascorporation/api-client'

export const ssoConfig: SsoConfig = {
  hubUrl: (import.meta.env.VITE_SSO_HUB_URL as string | undefined) ?? 'https://id.satelab.org',
  apiBaseUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',
  clientId: 'academy',
  redirectUri: `${window.location.origin}/auth/callback`,
  tokenStorageKey: 'token',
  userStorageKey: 'user',
}

// Staff accounts (instructor/admin/cccd_manager) manage their password in
// Gestión, not Academy — see enforce-must-change-password-gate. The hub's
// cross-subdomain sl_session cookie lets gestion.satelab.org pick the
// session back up without the user re-entering credentials.
export const GESTION_CHANGE_PASSWORD_URL =
  `${(import.meta.env.VITE_GESTION_URL as string | undefined) ?? 'https://gestion.satelab.org'}/change-password`
